import { cn } from "@/frontend/lib/utils";
import { patientStatusPresentation } from "@/frontend/utils/dashboard/patient-status";
import type { PatientStatus } from "@/server/types/patient-status";

/**
 * Lifecycle badge for one patient. The attention overlay wins over the
 * lifecycle state, so a `ready` patient with a broken health system still reads
 * as needing attention.
 */
export function PatientStatusBadge({
  status,
  needsAttention,
  className,
}: {
  status: PatientStatus;
  needsAttention: boolean;
  className?: string;
}) {
  const { label, dot } = patientStatusPresentation(status, needsAttention);

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-medium",
        needsAttention ? "border-amber-500/30 bg-amber-500/10 text-amber-700 dark:text-amber-400" : "bg-muted/40",
        className,
      )}
    >
      <span className={cn("size-1.5 shrink-0 rounded-full", dot)} />
      {label}
    </span>
  );
}
